import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { AuthService } from './core/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  auth = inject(AuthService);
  private breakpointObserver = inject(BreakpointObserver);

  isMobile = toSignal(
    this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches)),
    { initialValue: false }
  );

  // Sottomenu espandibili (Betting/Community/Settings): **mutuamente esclusivi**, un solo gruppo
  // aperto alla volta (toggleGroup chiude gli altri) - altrimenti la sidebar cresce senza
  // controllo se l'utente apre più gruppi in sequenza. Parte già sul gruppo giusto se l'utente è
  // su una di quelle pagine (es. dopo un refresh), così vede subito dove si trova.
  expandedGroup: 'betting' | 'community' | 'settings' | null =
      location.pathname.startsWith('/sure-bets')
      || location.pathname.startsWith('/middle-bets')
      || location.pathname.startsWith('/odd-movements')
      || location.pathname.startsWith('/sistemi')
      || location.pathname.startsWith('/schedine')
      || location.pathname.startsWith('/admin/error-correction-suggestions')
        ? 'betting'
      : location.pathname.startsWith('/feed') || location.pathname.startsWith('/leaderboard')
        ? 'community'
      : location.pathname.startsWith('/grabbers') || location.pathname.startsWith('/admin/users')
        ? 'settings'
      : null;

  toggleGroup(group: 'betting' | 'community' | 'settings') {
    this.expandedGroup = this.expandedGroup === group ? null : group;
  }
}
